import { TRPCClientError } from "@trpc/client";
import { TRPCTimeoutError } from "./TRPCTimeoutError";

/**
 * Checks if an error is a timeout error (504 Gateway Timeout) that should be retried.
 * This includes:
 * - TRPCTimeoutError (wraps 504 responses)
 * - TRPCClientError caused by a TRPCTimeoutError
 */
export function isTimeoutError(error: unknown): boolean {
  if (error instanceof TRPCTimeoutError) {
    return true;
  }

  if (error instanceof TRPCClientError) {
    if (error.cause instanceof TRPCTimeoutError) {
      return true;
    }
  }

  return false;
}
